module.exports = __webpack_public_path__ + "static/media/dn.c4f5d38c.jpg";